import { FETCH_SCHEDULE_AREA_FUNCTIONS, FETCH_SCHEDULE_AREA_FUNCTION } from '../actions/types';

const INITIAL_STATE = {
    items: [],
    detail: null,
    pagination: {
        currentPage: 1,
        total: 0,
        perPage: 30
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_SCHEDULE_AREA_FUNCTIONS: {
            const result = action.payload?.result || {};
            return {
                ...state,
                items: result.data || [],
                pagination: {
                    currentPage: Number(result.current_page || 1),
                    total: Number(result.total || 0),
                    perPage: Number(result.per_page || 30)
                }
            };
        }
        case FETCH_SCHEDULE_AREA_FUNCTION:
            return { ...state, detail: action.payload || null };
        default:
            return state;
    }
};
